// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yr07","colBig":"styles_colBig__2a49R","colSmall":"styles_colSmall__1bKI8","shopifyNameWrapper":"styles_shopifyNameWrapper__1fRsZ"};